<template>
  <transition name="shrink">
    <slot/>
  </transition>
</template>

<script>
export default {
  name: 'ShrinkTransition',
};
</script>

<style scoped lang="scss">
  @import "../../scss/variables";

  @keyframes shrink-sm {
    from {
      height: 0;
    }

    to {
      height: $titlebar-placeholder-sm;
    }
  }

  @keyframes shrink {
    from {
      height: 0;
    }

    to {
      height: $titlebar-placeholder-md;
    }
  }

  .shrink-enter-active {
    animation: shrink-sm 400ms ease-in-out;

    @media only screen and (min-width: $breakpoint-md) {
      animation: shrink 400ms ease-in-out;
    }
  }

  .shrink-leave-active {
    animation: shrink-sm 400ms ease reverse;

    @media only screen and (min-width: $breakpoint-md) {
      animation: shrink 400ms ease reverse;
    }
  }
</style>
